import React from 'react';
import EquipmentChoice from '../../components/EquipmentChoice/EquipmentChoice';
import GIETextField from '../../components/GIETextField/GieTextField';
import {FormValidator} from '../../util/form-validator';
import GIEButton from '../../components/GIEButton/GieButton';
import InputLabel from "@material-ui/core/InputLabel";
import {MenuItem} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import {Select} from "@mui/material";

const dataEquipment = [
  {label: 'Installer un nouvel équipement', value: 'new'},
  {label: 'Remplacer un équipement', value: 'replace'},
  //{label:'Autre intervention',value:'other'}
]

export default class EquipmentFormDetail extends React.Component<any, any> {
  formValidator: FormValidator = new FormValidator();

  constructor(props: any) {
    super(props);
    this.state = {
      type: {
        value: 'new',
        error: false,
        errorMessage: ''
      },
      informations: {
        value: '',
        error: false,
        errorMessage: ''
      },
      gearToInstall: {
        value: '',
        error: false,
        errorMessage: ''
      },
      gearToReplace: {
        value: '',
        error: false,
        errorMessage: ''
      },
      gearToInstallError: false,
      gearToReplaceError: false
    }
  }

  changeChoice = (event) => {
    let type = this.state.type;
    type.value = event.target.value;
    this.setState({type})
  }
  gearToInstall = (value) => {
    let gearToInstall = this.state.gearToInstall;
    gearToInstall.value = value;
    this.setState({gearToInstall})
  }

  gearToReplace = (value) => {
    let gearToReplace = this.state.gearToReplace;
    gearToReplace.value = value;
    this.setState({gearToReplace});
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const error = this.formValidator.returnError(value, name);
    this.setState({
      informations: {
        value,
        error: error.error,
        errorMessage: error.errorMessage
      }
    });
  }

  checkGearError = () => {
    let error = false;
    if (!this.state.gearToInstall.value.length) {
      this.setState({gearToInstallError: true});
      error = true
    }

    if (!this.state.gearToReplace.value.length && this.state.type.value !== 'new') {
      this.setState({gearToReplaceError: true});
      error = true
    }
    return error;
  }

  checkValidForm = () => {
    let isError = this.checkGearError();
    this.checkGearError();
    return isError;
  }

  handleSubmit = () => {
    if (this.checkValidForm() === false) {
      const data = {
        type: this.state.type,
        informations: this.state.informations,
        gearToInstall: this.state.gearToInstall,
        gearToReplace: this.state.gearToReplace
      }
      setTimeout(() => {
        this.props.next(data)
      }, 200);
    }
  }

  render() {
    return (
      <div>
        <FormControl variant='outlined' fullWidth margin="normal" className="mt-4">
          <InputLabel id="need-lbl" shrink disableAnimation className="gie-label" required>
            Vous souhaitez
          </InputLabel>
          <Select labelId="need-lbl" value={this.state.type.value} fullWidth variant="outlined"
                  onChange={this.changeChoice}>
            {
              dataEquipment.map((item) => <MenuItem value={item.value} key={item.value}>
                {item.label}
              </MenuItem>)
            }
          </Select>
        </FormControl>
        {this.state.type.value !== 'new' &&
            <EquipmentChoice gearError={this.state.gearToReplaceError} emit={this.gearToReplace}
                             title="Quel équipement souhaitez-vous remplacer ?"/>}
        <EquipmentChoice gearError={this.state.gearToInstallError} emit={this.gearToInstall}
                         title={'Quel équipement souhaitez-vous installer ?'}/>

        <GIETextField label="Informations complémentaires"
                      onChange={this.changeHandler}
                      name="informations"
                      value={this.state.informations.value}
                      error={this.state.informations.error}
                      helperText={this.state.informations.errorMessage}
                      multiline
                      rows={3}/>
        <div className="text-center my-4">
          <GIEButton onClick={this.handleSubmit} classes={{root: 'blue-btn'}}>Suivant</GIEButton>
        </div>
      </div>
    );
  }
}
